import lodash from 'lodash'
import React, { useEffect } from 'react'

import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field, {
  FieldPrefix,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import { usePrevious } from '../../../../../1stlog-ui/src/hooks'
import AddressPickerAdvanced from '../../../AddressPickerAdvanced'
import AddressPickerAdvancedReadonly from '../../../AddressPickerAdvanced/Readonly'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { useProductSettings } from '../../Products'
import { getAddressPickerLabels } from '../../utils/getAddressPickerLabels'

interface TNeutralSenderProps
  extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  readonly?: boolean
}

const NeutralSender = (props: TNeutralSenderProps): React.ReactElement => {
  const { readonly, ...rest } = props

  const productSettings = useProductSettings()

  const [isActive, setIsActive] = useField('isActive', {
    asState: true,
  })
  const [, setAddress] = useField('address', { asState: true })

  const previousProductSettings = usePrevious(productSettings)
  useEffect(() => {
    // check if product has changed
    if (
      previousProductSettings &&
      !lodash.isEqual(previousProductSettings, productSettings) &&
      productSettings
    ) {
      const { neutralSenderActiveByDefault, neutralSenderAddress = {} } =
        productSettings

      // check if active by default
      setIsActive(Boolean(neutralSenderActiveByDefault))

      // set default address if any
      setAddress(neutralSenderAddress)
    }
  }, [productSettings])

  if (!productSettings) {
    return <></>
  }

  const { neutralSendingEnabled, neutralSenderEditable } = productSettings

  return (
    <>
      {neutralSendingEnabled && (!readonly || isActive) && (
        <OrderEntryCard
          {...rest}
          title={i18n.t('order_neutralSending', 'Neutralversand')}
        >
          {!readonly && (
            <Field name="isActive">
              <Checkbox>
                {i18n.t('enable_neutral_sending', 'Neutralversand aktivieren')}
              </Checkbox>
            </Field>
          )}
          {isActive && (
            <FieldPrefix prefix="address">
              {!readonly && neutralSenderEditable ? (
                <AddressPickerAdvanced labels={getAddressPickerLabels()} />
              ) : (
                <AddressPickerAdvancedReadonly />
              )}
            </FieldPrefix>
          )}
        </OrderEntryCard>
      )}
    </>
  )
}

export default NeutralSender
